<template>
    <div id="contenedor-listado-catalogo-entidades-mobiles">
        <template
            v-for="(entidad, index) in listadoEntidades">
            <v-card
                :key="index"
                class="mb-2">
                <v-card-title
                  class="justify-space-between">
                  <div
                    class="d-inline-block text-truncate">
                    {{ entidad.nombre }}
                  </div>
                  <div
                    class="d-inline-block">
                    <opciones
                      :entidad="entidad">
                    </opciones>
                  </div>
                </v-card-title>
                <v-card-text>
                    {{ entidad.nombreCorto }}
                </v-card-text>
            </v-card>
        </template>
    </div>
</template>

<script>
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoCatalogoEntidadesMobiles',
  props: {
    listadoEntidades: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">

</style>
